import { Tooltip } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import React from 'react';

const ETABox = (props) => {
  const {
    requestedArrival,
    requestedDeparture,
    estimatedArrival,
    estimatedDeparture,
    showEta,
  } = props;

  if (!showEta || !estimatedArrival || !estimatedDeparture) {
    return (
      <Box display="flex" alignItems="flex-start" flexDirection="column">
        <Box fontSize={10} color="#959393">
          {requestedArrival.format('h:mm a')}
          {' - '}
          {requestedDeparture.format('h:mm a')}
        </Box>
      </Box>
    );
  }

  // Only compare the times (hours & minutes), not the dates.
  const momentToMinutes = (m) => m.minutes() + m.hours() * 60;

  const arrivalTooEarly =
    momentToMinutes(estimatedArrival) < momentToMinutes(requestedArrival);
  const departureTooLate =
    momentToMinutes(estimatedDeparture) > momentToMinutes(requestedDeparture);

  const tooltip = (
    <span>
      Customer Requested: {requestedArrival.format('h:mm a')} -{' '}
      {requestedDeparture.format('h:mm a')}
      <br />
      ETA: {estimatedArrival.format('h:mm a')} -{' '}
      {estimatedDeparture.format('h:mm a')}
    </span>
  );

  return (
    <Tooltip title={tooltip}>
      <Box display="flex" alignItems="flex-start" flexDirection="column">
        <Box fontSize={10} color="#959393">
          <span style={{ color: arrivalTooEarly ? 'red' : '#959393' }}>
            {requestedArrival.format('h:mm a')}
          </span>
          {' - '}
          <span style={{ color: departureTooLate ? 'red' : '#959393' }}>
            {requestedDeparture.format('h:mm a')}
          </span>
        </Box>
        <Box
          fontSize={10}
          color={arrivalTooEarly || departureTooLate ? 'red' : '#959393'}
        >
          ETA: {estimatedArrival.format('h:mm a')}
          {' - '}
          {estimatedDeparture.format('h:mm a')}
        </Box>
      </Box>
    </Tooltip>
  );
};

export default ETABox;
